import { GlobalConstants } from "../../../../../common/constants/global.constant";

export const storesCountriesConstants =
    [
        {
            name: GlobalConstants.ALGERIA,
            order: 'A',
            eName:'Algeria'
        },
        {
            name: GlobalConstants.ARGENTINA,
            order: 'A',
            eName: 'Argentina'
        },
        {
            name: GlobalConstants.AUSTRALIA,
            order: 'A',
            eName:'Australia'
        },
        {
            name: GlobalConstants.AUSTRIA,
            order: 'A',
            eName:'Austria'
        },
        {
            name: GlobalConstants.BELARUS,
            order: 'B',
            eName: 'Belarus'
        },
        {
            name: GlobalConstants.BELGIUM,
            order: 'B',
            eName: 'Belgium'
        },
        {
            name: GlobalConstants.BRAZIL,
            order: 'B',
            eName: 'Brazil'
        },
        {
            name: GlobalConstants.BULGARIA,
            order: 'B',
            eName: 'Bulgaria'
        },
        {
            name: GlobalConstants.CANADA,
            order: 'C',
            eName: 'Canada'
        },
        {
            name: GlobalConstants.CHILE,
            order: 'C',
            eName: 'Chile'
        },
        {
            name: GlobalConstants.CHINA,
            order: 'C',
            eName: 'Mainland China'
        },
        {
            name: GlobalConstants.COLOMBIA,
            order: 'C',
            eName: 'Colombia'
        },
        {
            name: GlobalConstants.CROATIA,
            order: 'C',
            eName: 'Croatia'
        },
        {
            name: GlobalConstants.CYPRUS,
            order: 'C',
            eName: 'Cyprus'
        },
        {
            name: GlobalConstants.CZECH_REPUBLIC,
            order: 'C',
            eName: 'Czech Republic'
        },
        {
            name: GlobalConstants.DENMARK,
            order: 'D',
            eName: 'Denmark'
        },
        {
            name: GlobalConstants.EGYPT,
            order: 'E',
            eName: 'Egypt'
        },
        {
            name: GlobalConstants.ESTONIA,
            order: 'E',
            eName: 'Estonia'
        },
        {
            name: GlobalConstants.FINLAND,
            order: 'F',
            eName: 'Finland'
        },
        {
            name: GlobalConstants.FRANCE,
            order: 'F',
            eName: 'France'
        },
        {
            name: GlobalConstants.GERMANY,
            order: 'G',
            eName: 'Germany'
        },
        {
            name: GlobalConstants.GREECE,
            order: 'G',
            eName: 'Greece'
        },
        {
            name: GlobalConstants.HONG_KONG,
            order: 'H',
            eName: 'Hong Kong (SAR)'
        },
        {
            name: GlobalConstants.HUNGARY,
            order: 'H',
            eName: 'Hungary'
        },
        {
            name: GlobalConstants.ICELAND,
            order:  'I',
            eName:  'Iceland'
        },
        {
            name: GlobalConstants.INDIA,
            order: 'I',
            eName: 'India'
        },
        {
            name: GlobalConstants.INDONESIA,
            order: 'I',
            eName: 'Indonesia'
        },
        {
            name: GlobalConstants.IRELAND,
            order: 'I',
            eName: 'Ireland'
        },
        {
            name: GlobalConstants.ISRAEL,
            order: 'I',
            eName: 'Israel'
        },
        {
            name: GlobalConstants.ITALY,
            order: 'I',
            eName: 'Italy'
        },
        {
            name: GlobalConstants.JAPAN,
            order: 'J',
            eName: 'Japan'
        },
        {
            name: GlobalConstants.KAZAKHSTAN,
            order: 'K',
            eName: 'Kazakhstan'
        },
        {
            name: GlobalConstants.KENYA,
            order: 'K',
            eName: 'Kenya'
        },
        {
            name: GlobalConstants.KOREA,
            order: 'K',
            eName: 'Korea'
        },
        {
            name: GlobalConstants.LATVIA,
            order: 'L',
            eName: 'Latvia'
        },
        {
            name: GlobalConstants.LEBANON,
            order: 'L',
            eName: 'Lebanon'
        },
        {
            name: GlobalConstants.LITHUANIA,
            order: 'L',
            eName: 'Lithuania'
        },
        {
            name: GlobalConstants.MALAYSIA,
            order: 'M',
            eName: 'Malaysia'
        },
        {
            name: GlobalConstants.MEXICO,
            order: 'M',
            eName: 'Mexico'
        },
        {
            name: GlobalConstants.MOROCCO,
            order: 'M',
            eName: 'Morocco'
        },
        {
            name: GlobalConstants.NETHERLANDS,
            order: 'N',
            eName: 'Netherlands'
        },
        {
            name: GlobalConstants.NEW_ZEALAND,
            order: 'N',
            eName: 'New Zealand'
        },
        {
            name: GlobalConstants.NIGERIA,
            order: 'N',
            eName: 'Nigeria'
        },
        {
            name: GlobalConstants.NORWAY,
            order: 'N',
            eName: 'Norway'
        },
        {
            name: GlobalConstants.PAKISTAN,
            order: 'P',
            eName: 'Pakistan'
        },
        {
            name: GlobalConstants.PERU,
            order: 'P',
            eName: 'Peru'
        },
        {
            name: GlobalConstants.PHILIPPINES,
            order: 'P',
            eName: 'Philippines'
        },
        {
            name: GlobalConstants.POLAND,
            order: 'P',
            eName: 'Poland'
        },
        {
            name: GlobalConstants.PORTUGAL,
            order: 'P',
            eName: 'Portugal'
        },
        {
            name: GlobalConstants.ROMANIA,
            order: 'R',
            eName: 'Romania'
        },
        {
            name: GlobalConstants.RUSSIA,
            order: 'R',
            eName: 'Russia'
        },
        {
            name: GlobalConstants.SAUDI_ARABIA,
            order: 'S',
            eName: 'Saudi Arabia'
        },
        {
            name: GlobalConstants.SINGAPORE,
            order: 'S',
            eName: 'Singapore'
        },
        {
            name: GlobalConstants.SLOVAKIA,
            order: 'S',
            eName: 'Slovakia'
        },
        {
            name: GlobalConstants.SOUTH_AFRICA,
            order: 'S',
            eName: 'South Africa'
        },
        {
            name: GlobalConstants.SPAIN,
            order: 'S',
            eName: 'Spain'
        },
        {
            name: GlobalConstants.SRI_LANKA,
            order: 'S',
            eName: 'Sri Lanka'
        },
        {
            name: GlobalConstants.SWEDEN,
            order: 'S',
            eName: 'Sweden'
        },
        {
            name: GlobalConstants.SWITZERLAND,
            order: 'S',
            eName: 'Switzerland'
        },
        {
            name: GlobalConstants.TAIWAN,
            order: 'T',
            eName: 'Taiwan'
        },
        {
            name: GlobalConstants.THAILAND,
            order: 'T',
            eName: 'Thailand'
        },
        {
            name: GlobalConstants.TURKEY,
            order: 'T',
            eName: 'Turkey'
        },
        {
            name: GlobalConstants.UKRAINE,
            order: 'U',
            eName: 'Ukraine'
        },
        {
            name: GlobalConstants.UNITED_ARAB_EMIRATES,
            order: 'U',
            eName: 'United Arab Emirates'
        },
        {
            name: GlobalConstants.UNITED_KINGDOM,
            order: 'U',
            eName: 'United Kingdom'
        },
        {
            name: GlobalConstants.UNITED_STATES,
            order: 'U',
            eName: 'United States'
        },
        {
            name: GlobalConstants.URUGUAY,
            order: 'U',
            eName: 'Uruguay'
        },
        {
            name: GlobalConstants.VIETNAM,
            order: 'V',
            eName: 'Vietnam'
        }
    ];
